import { render, staticRenderFns } from "./fbpMain.vue?vue&type=template&id=bf241324"
import script from "./fbpMain.vue?vue&type=script&lang=js"
export * from "./fbpMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports